import React from 'react';
import { Chip } from 'src/shared/design-system/Chip';
import { Follow } from 'src/shared/design-system/Icon';
import styled from 'styled-components';
import { Colors, Font, Spacing } from 'web-common/src/shared/styles';

const StyledChip = styled(Chip)`
  font-size: ${Font.Size.XXS};
  color: ${Colors.GRAY_DARK_30};
  background-color: ${Colors.GRAY_LITE_30};
  font-weight: ${Font.Weight.SEMI_BOLD};
  box-shadow: none;
`;

const StyledFollow = styled(Follow)`
  margin: -1px ${Spacing.EIGHTH} 0 -${Spacing.EIGHTH};
`;

export const FollowChip: React.FC = () => (
  <StyledChip text={'Following'} icon={<StyledFollow height={11} width={11} />} />
);
